import { FILTER_TYPES } from "taltech-styleguide";

export const colEmail = {
  classes: "w-20",
  dataField: "email",
  sort: true,
  text: "Email",
  filterObject: {
    defaultValue: undefined,
    minChars: 3,
    placeholder: "Email",
    type: FILTER_TYPES.TEXT,
  },
};
